export default __webpack_public_path__ + "static/media/banner.fa18f459.png";